import React, { useEffect, useState } from 'react';
import './Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust based on your structure

import factoids from '../../info/factoids';
import FactoidSection from '../../components/FactoidSection';

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/solutionCentralOffice.mp4",
    poster: "/videos/solutionCentralOffice.jpg",
    heading: "Next-Generation Fiber Solutions for Central Offices & Headends",
    subheading: "Where modern networks converge and tomorrow’s service delivery begins.",
    buttonLink: "/solutions"
  }
];

function SolutionCentralOffice() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');


const productFamilies = [
  'Fiber Cable Assemblies',
  'Passive Optical Components',
  // 'Cassettes',
  'Fiber Panels',
  'Frames',
];

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

const topByFamily = productFamilies.map(famName => {
  const matchingProducts = filteredProducts.filter(
    p => (p.productFamily || '').trim() === famName
  );
  if (matchingProducts.length === 0) return null;

  const topProduct = matchingProducts.reduce((best, current) =>
    Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
  );

  return { family: famName, topProduct };
}).filter(Boolean); // remove nulls if a family has no products

const [familyIndex, setFamilyIndex] = useState(0);
const [familySlidesPerView, setFamilySlidesPerView] = useState(3);

useEffect(() => {
  const update = () => {
    if (window.innerWidth <= 768) {
      setFamilySlidesPerView(1);
    } else if (window.innerWidth <= 1100) {
      setFamilySlidesPerView(2);
    } else {
      setFamilySlidesPerView(3);
    }
  };

  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}, []);

const familyMaxIndex = Math.max(topByFamily.length - familySlidesPerView, 0);

const nextFamily = () => {
  setFamilyIndex(prev => Math.min(prev + 1, familyMaxIndex));
};

const prevFamily = () => {
  setFamilyIndex(prev => Math.max(prev - 1, 0));
};

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
          disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p>{slides[0].subheading}</p>
            <a href={'/support'} className="cta-button">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      <svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

      <div className="solutions-section-1">
        <div className="solutions-section-1-image-container">
          <img src="/images/solutions/centralOffice.jpg" alt="Central Office" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">Innovation for high density and simplified management</h2>
          <p className="solution-section-1-description">Central Offices and Headends are transforming into intelligent aggregation points, demanding greater bandwidth, higher density, and low-latency performance. With the rise of video, 5G backhaul, and high-capacity services, operators face mounting pressure to upgrade legacy infrastructure. In this dynamic environment, fiber innovations from Go!Foton are the foundation for speed, flexibility, and operational efficiency.</p>
        </div>
      </div>

      <FactoidSection
              solution="central-office"
              title="Telecom & MSOs are upgrading to meet the moment"
              description=""
            />


      <div className="solutions-section-checklist">
        <div className="solutions-section-checklist-left">
          <h2 className="solutions-section-checklist-heading">Engineered for the modern network edge</h2>
          <div className="solutions-section-checklist-image-wrapper">
            <img src="/images/solutions/centralOffice2.jpg" alt="Central Office" />
          </div>
        </div>

        <div className="solutions-section-checklist-right">
          <p className="solutions-section-checklist-description">From rapid installation to long-term scalability, our optical solutions solve the toughest connectivity challenges inside Central Offices and Headends. With compact footprints, technician-friendly design, and unrivaled performance, we enable service providers to upgrade with confidence and keep customers connected.</p>
          <ul className="solutions-section-checklist-points">
            <li>Quick Deployment</li>
            <li>Scalable</li>
            <li>Technician-Friendly</li>
            <li>High-Density</li>
            <li>Customizable</li>
          </ul>
        </div>
      </div>


    <section className="solution-products-section">
      <h2>Next-Gen Fiber Solutions for Central Offices and Headends</h2>
      <p className="solution-products-section-description">Our innovative fiber optic solutions are engineered to support the evolving demands of your networks, ensuring superior speed, efficiency, and adaptability.</p>

      {/* <p className="solution-products-section-description">Our innovative fiber optic solutions are engineered to support the evolving demands of your networks, ensuring superior speed, efficiency, and adaptability.</p> */}

<div className="products-grid">
  {topByFamily.map(({ family, topProduct }) => (
    <div key={family} className="product-card">
      {topProduct.image ? (
        <img
          src={topProduct.image}
          alt={family}
          style={{ width: '100%', height: 200, objectFit: 'cover' }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            height: 215,
            backgroundColor: '#ddd',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontStyle: 'italic',
            color: '#666',
          }}
        >
          No Image Available
        </div>
      )}
      <h3>{family}</h3>
      <a
        href={`/${family.toLowerCase().replace(/\s+/g, '-')}`}
        className="learn-more"
      >
        Learn More
      </a>
    </div>
  ))}
</div>

    </section>


        <div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>

    </div>

    
  );
}

export default SolutionCentralOffice;
